import React from 'react';
import PropTypes from 'prop-types';

import DetailLabel from './DetailLabel';
import DetailValue from './DetailValue';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  testId: PropTypes.string
};

const defaultProps = {
  className: undefined,
  children: undefined,
  testId: undefined
};

const Detail = ({ className, children, testId }) => {
  return (
    <div data-testid={testId} id="styledDetail" className={className}>
      {children}
    </div>
  );
};

Detail.propTypes = propTypes;
Detail.defaultProps = defaultProps;

Detail.Label = DetailLabel;
Detail.Value = DetailValue;

export default Detail;
